<template>

    <div class="last_evals_wrap">


        <div class="evals_head_list">
            <div class="last_evals_label">
                <iconEval /> <span>{{ $t('modules.dashboard.lastEvals.title') }}</span>
            </div>
            <div class='evals_tabs'>
                <div class="completed_evals_tab" :class="{active: (selectedTab == 'completed')}" @click="selectedTab = 'completed'">
                    <completedMark :evaluation="{completed: true}" /> {{ $t('modules.dashboard.lastEvals.completed') }}
                </div>
                <div class="pending_evals_tab" :class="{active: (selectedTab == 'pending')}" @click="selectedTab = 'pending'">
                    <completedMark :evaluation="{completed: false}" /> {{ $t('modules.dashboard.lastEvals.pending') }}
                </div>
            </div>
        </div>
        <div class="last_evals_list" v-if="currentList.length > 0">

            <LastEvalsItem v-for="(evaluation, index) in currentList" :key="evaluation.id" :index="index" :evaluation="evaluation" />

        </div>
        <div class="last_evals_no_items" v-else>

            <div>{{ $t('modules.dashboard.lastEvals.noEvalYet') }}</div>
        </div>
    </div>

</template>

<script>
import LastEvalsItem from './lastEvalsItem'

export default {
    name: 'LastEvalsWrap',
    components: {
        LastEvalsItem
    },
    data(){
        return {
            selectedTab: 'completed'
        }
    },
    computed: {
        evalsList(){
            return this._.orderBy(this.$store.state.EvalStore.evalsList, ['created_at'], ['desc'])
        },
        completedEvals(){
            return this.evalsList.filter((evaluation) => {
                return evaluation.completed
            }).slice(0, 4)
        },
        pendingEvals(){
            return this.evalsList.filter((evaluation) => {
                return !evaluation.completed
            }).slice(0, 4)
        },
        currentList(){
            if(this.selectedTab == 'completed'){
                return this.completedEvals
            }else{
                return this.pendingEvals
            }
        }
    },
    methods: {
    }
}


</script>

<style lang="scss">
.last_evals_wrap{
    margin-bottom: 30px;
    .evals_head_list{
        display: flex;
        border-bottom: 1px solid $grey-lighter;
        .last_evals_label{
            font-weight: 600;
            font-size: 1.15rem;
            padding: 12px 16px;
            display: flex;
            align-items: center;
            text-transform: uppercase;
            svg{
                height: 24px;
                margin-right: 12px;
                fill: $grey;
            }
        }
        .evals_tabs{
            display: flex;
            & > div{
                display: flex;
                align-items: center;
                padding: 12px 16px;
                border-bottom: 4px solid rgba(0,0,0,0);
                cursor: pointer;
                user-select: none;
                text-transform: uppercase;
                .completed_mark{
                    margin-right: 8px;
                }
                &:hover{
                    border-color: $grey-lighter;
                }
                &.active{
                    border-color: $info;
                }
            }
        }
    }
    .last_evals_no_items{
        font-size: 1.2rem;
        padding: 15px;
        background-color: $white-ter;
        border-bottom: 1px solid $grey-lighter;
    }
}
</style>